import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class GetAllOrders extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Order/GetAll");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetASingleOrder extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Order/Get");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class ChangeOrderStatus extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Order/ChangeOrderStatus");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class AddLessonToUser extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Order/AddLessonToUser");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class RemoveLessonFromUser extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Order/RemoveLessonToUser");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class AddLessonToUserArray extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Order/AddLessonToUserArray");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetOrdersOfMasterDiscountCode extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Order/GetMasterDiscountCodeOrderDetailsByMasterDiscountId");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetLessonCategoryOrderDetails extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Order/GetOrderDetail");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

export {
  GetAllOrders,
  GetASingleOrder,
  ChangeOrderStatus,
  AddLessonToUser,
  RemoveLessonFromUser,
  AddLessonToUserArray,
  GetOrdersOfMasterDiscountCode,
  GetLessonCategoryOrderDetails,
};
